import {
  CREATE_ANONYMOUS_SESSION_REQUEST,
  CREATE_ANONYMOUS_SESSION_SUCCESS,
  CREATE_ANONYMOUS_SESSION_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT_REQUEST,
  LOGOUT_SUCCESS,
  LOGOUT_FAILURE,
  CHECK_EMAIL_REQUEST,
  CHECK_EMAIL_SUCCESS,
  CHECK_EMAIL_FAILURE,
  RESET_CHECKED_EMAIL,
  SET_AUTHENTICATION_MODAL_IS_VISIBLE,
  PATCH_PHONE_NUMBER_REQUEST,
  PATCH_PHONE_NUMBER_SUCCESS,
  PATCH_PHONE_NUMBER_FAILURE,
  POST_FORGOT_EMAIL_SUCCESS,
  RESET_FORGOT_PASSWORD,
  EMAIL_IS_UNCONFIRMED,
  RESET_AUTH_REDUCER,
  GET_APP_CONFIG,
} from './authTypes';

export const initialState = {
  requestingCheckEmail: false,
  emailHasBeenChecked: false,
  requestingLogin: false,
  isAuthenticated: false,
  authenticationModalIsVisible: false,
  requestingPatchPhoneNumber: false,
  patchPhoneNumberError: null,
  forgotPasswordSuccess: false,
  emailIsUnconfirmed: false,
  appConfig: null,
};

export default function(state = initialState, action) {
  switch (action.type) {
    case CREATE_ANONYMOUS_SESSION_REQUEST:
      return {
        ...state,
        requestingCreateAnonymousSession: true,
      };
    case CREATE_ANONYMOUS_SESSION_SUCCESS:
      return {
        ...state,
        requestingCreateAnonymousSession: false,
        session_id: action.response.data.session_id,
      };
    case CREATE_ANONYMOUS_SESSION_FAILURE:
      return {
        ...state,
        requestingCreateAnonymousSession: false,
      };
    case LOGIN_REQUEST:
      return {
        ...state,
        requestingLogin: true,
      };
    case LOGIN_SUCCESS:
      return {
        ...state,
        session_id: action.token,
        isAuthenticated: true,
        requestingLogin: false,
      };
    case LOGIN_FAILURE:
      return {
        ...state,
        requestingLogin: false,
      };
    case LOGOUT_REQUEST:
      return {
        ...state,
        requestingLogout: true,
      };
    case LOGOUT_SUCCESS:
      return {
        ...state,
        requestingLogout: false,
        isAuthenticated: false,
        session_id: null,
      };
    case LOGOUT_FAILURE:
      return {
        ...state,
        requestingLogout: false,
      };
    case CHECK_EMAIL_REQUEST:
      return {
        ...state,
        requestingCheckEmail: true,
      };
    case CHECK_EMAIL_SUCCESS:
      return {
        ...state,
        requestingCheckEmail: false,
        emailIsAvailable: action.emailIsAvailable,
        emailHasBeenChecked: true,
        checkedEmail: action.checkedEmail,
      };
    case CHECK_EMAIL_FAILURE:
      return {
        ...state,
        requestingCheckEmail: false,
      };
    case RESET_CHECKED_EMAIL:
      return {
        ...state,
        emailHasBeenChecked: false,
      };
    case SET_AUTHENTICATION_MODAL_IS_VISIBLE:
      return {
        ...state,
        authenticationModalIsVisible: action.bool,
      };
    case PATCH_PHONE_NUMBER_REQUEST:
      return {
        ...state,
        requestingPatchPhoneNumber: true,
        patchPhoneNumberError: null,
      };
    case PATCH_PHONE_NUMBER_SUCCESS:
      return {
        ...state,
        requestingPatchPhoneNumber: false,
      };
    case PATCH_PHONE_NUMBER_FAILURE:
      return {
        ...state,
        requestingPatchPhoneNumber: false,
        patchPhoneNumberError: action.error,
      };
    case RESET_FORGOT_PASSWORD:
      return {
        ...state,
        forgotPasswordSuccess: false,
      };
    case POST_FORGOT_EMAIL_SUCCESS:
      return {
        ...state,
        forgotPasswordSuccess: true,
      };
    case EMAIL_IS_UNCONFIRMED:
      return {
        ...state,
        emailIsUnconfirmed: true,
        // session_id: action.token,
      };
    case RESET_AUTH_REDUCER:
      return {
        ...state,
        emailIsUnconfirmed: initialState.emailHasBeenChecked,
        requestingCheckEmail: initialState.requestingCheckEmail,
        emailHasBeenChecked: initialState.emailHasBeenChecked,
        requestingLogin: initialState.requestingLogin,
      };
    case GET_APP_CONFIG:
      return {
        ...state,
        appConfig: action.appConfig,
      };
    default:
      return state;
  }
}
